import instance from "../../utils/axios";

// ✅ Save Language Meta
export const saveLanguageMeta = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) =>
    formData.append(key, val ?? "")
  );

  const response = await instance.post("/churches/languagemetas/save", formData);
  return response.data;
};
